import React, { useState } from 'react';
import {
    FaMapMarkerAlt,
    FaWhatsapp,
    FaInstagram,
    FaFacebookF,
} from 'react-icons/fa';
import './Contact.css';
import { CONTACT_INFO } from '../constants/data';
import { useSettings } from '../context/SettingsContext';

// Map icon name strings (from data.js) → react-icons components
const CONTACT_ICONS = {
    FaMapMarkerAlt,
    FaWhatsapp,
    FaInstagram,
    FaFacebookF,
};

const ICON_COLOR = '#6B1A1A';

export default function Contact() {
    const SITE_CONFIG = useSettings();
    const [form, setForm] = useState({ name: '', phone: '', message: '' });
    const [sent, setSent] = useState(false);

    const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

    const handleSend = () => {
        if (!form.name || !form.message) return;
        const msg = `Hello ${SITE_CONFIG.brandName}! 👋%0A%0AName: ${form.name}%0APhone: ${form.phone}%0A%0A${form.message}`;
        window.open(`https://wa.me/${SITE_CONFIG.whatsapp}?text=${msg}`, '_blank');
        setSent(true);
    };

    return (
        <div className="contact-page">

            {/* Hero */}
            <div className="contact-hero">
                <p className="section-subtitle">Get in Touch</p>
                <h1 className="section-title">Contact Us</h1>
                <div className="gold-rule" style={{ maxWidth: 280, margin: '16px auto 0' }} />
            </div>

            <div className="contact-layout">

                {/* Info cards */}
                <div className="contact-info">
                    <p className="contact-intro">
                        We'd love to hear from you. Whether it's a custom cake inquiry, a special occasion, or just a hello — reach out and we'll get back to you promptly.
                    </p>

                    <div className="info-cards">
                        {CONTACT_INFO.map((card, i) => {
                            const Icon = CONTACT_ICONS[card.icon];
                            return (
                                <div className="info-card" key={i}>
                                    <span className="info-icon">
                                        {Icon && <Icon size={22} color={ICON_COLOR} />}
                                    </span>
                                    <div>
                                        <p className="info-label">{card.label}</p>
                                        {card.link ? (
                                            <a href={card.link} target="_blank" rel="noopener noreferrer" className="info-value link">
                                                {card.value}
                                            </a>
                                        ) : (
                                            <p className="info-value">{card.value}</p>
                                        )}
                                        <p className="info-sub">{card.sub}</p>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                {/* Form */}
                <div className="contact-form-box">
                    <h2 className="cart-heading" style={{ marginBottom: 24 }}>Send a Message</h2>

                    <div className="form-group">
                        <label>Your Name</label>
                        <input
                            name="name"
                            placeholder="Full name"
                            value={form.name}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group">
                        <label>Phone (optional)</label>
                        <input
                            name="phone"
                            placeholder="+92 3XX XXXXXXX"
                            value={form.phone}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group">
                        <label>Message</label>
                        <textarea
                            name="message"
                            rows={5}
                            placeholder="Tell us about your cake or occasion..."
                            value={form.message}
                            onChange={handleChange}
                        />
                    </div>

                    {sent ? (
                        <div className="order-sent">✓ Message sent via WhatsApp! We'll reply shortly.</div>
                    ) : (
                        <button className="whatsapp-order-btn" onClick={handleSend}>
                            <FaWhatsapp size={18} color="#fff" style={{ marginRight: 8 }} />
                            Send via WhatsApp
                        </button>
                    )}
                </div>

            </div>
        </div>
    );
}
